import Admin from './ui/Admin';

export default Admin;